module.exports = __webpack_public_path__ + "img/ophtalmic.227a918d.svg";